import { LdsModal } from "@elilillyco/ux-lds-react";
import "./../../assets/scss/details/deleteSpecModal.scss";
const BrandsModal = ({
  isBrandAccessOpen,
  setBrandAccessOpen,
  branddata
}) => {
  return (
    <>
      <LdsModal
        modalId="user-brand-modal"
        className="text-center"
        open={isBrandAccessOpen}
        setModalOpen={setBrandAccessOpen}
        modalSizeClass="col-4"
      >
         <div
      style={{
        height: '300px', // Set the height of the scrollable area
        overflowY: 'scroll', // Enable vertical scrolling
        border: '1px solid #ccc', // Optional, just for styling
        padding: '10px',
        textAlign: 'left',
      }}
    >
      <ul>
        {branddata.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </div>
        {/* <h1>{convertArray(branddata)}</h1> */}
      </LdsModal>
    </>
  );
};
export default BrandsModal;
